import { PERCENTILE_TOGGLE_STATE } from '../actionTypes/shared/apiActionTypes';

export const setPercentileToggleState = isPercentileShown => ({
    type: PERCENTILE_TOGGLE_STATE.SET,
    isPercentileShown,
});

export const clearPercentileToggleState = () => ({
    type: PERCENTILE_TOGGLE_STATE.CLEAR,
});
